import React from 'react';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa';
import { Print, PrintNoBorder, PrintOutline } from './styles';

export default function PrintDeliveryButton({
  user,
  printClick,
  printDeliverySession,
  loadingPrinter,
  item,
  getOrders,
  componentRef,
  handleFetchDataToPrint,
  fetchDataPayload,
}) {
  const useReactToPrint = !!componentRef;
  const hasLogisticId = !!item?.logistic_id;

  const renderWebPrintButton = () => {
    if (useReactToPrint) {
      return (
        <ReactToPrint
          onBeforeGetContent={async () => {
            await getOrders();
          }}
          trigger={() => (
            <Print>
              <FaPrint color="#fff" size={20} />
              Imprimir via de entrega
            </Print>
          )}
          content={() => componentRef.current}
        />
      );
    }

    return (
      <Print onClick={() => handleFetchDataToPrint(fetchDataPayload)}>
        <FaPrint color="#fff" size={20} />
        Imprimir via de entrega
      </Print>
    );
  };

  const renderIsPrintedOnWebButton = () => {
    if (hasLogisticId) {
      return (
        <Print onClick={() => handleFetchDataToPrint(fetchDataPayload)}>
          <FaPrint color="#fff" size={20} />
          Imprimir
        </Print>
      );
    }

    return (
      <PrintOutline onClick={() => handleFetchDataToPrint(fetchDataPayload)}>
        <FaPrint color="#ff2c3a" size={20} />
        Imprimir
      </PrintOutline>
    );
  };

  if (user.is_printed_on_web) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {renderIsPrintedOnWebButton()}
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <PrintNoBorder onClick={printClick}>
        <FaPrint color="#ff2c3a" size={20} />
        Imprimir em ambiente de produção
      </PrintNoBorder>

      {user.print_bills_delivery_on_web ? (
        renderWebPrintButton()
      ) : (
        <>
          {hasLogisticId ? (
            <Print onClick={printDeliverySession} disabled={loadingPrinter}>
              <FaPrint color="#fff" size={20} />
              Imprimir via de entrega
            </Print>
          ) : (
            <PrintOutline onClick={printDeliverySession} disabled={loadingPrinter}>
              <FaPrint color="#ff2c3a" size={20} />
              Imprimir via de entrega
            </PrintOutline>
          )}
        </>
      )}
    </div>
  );
}